export const getFormattedTime = (timeString: string, locale: string) => {
  const currentDate = new Date();

  currentDate.setHours(parseInt(timeString.split(':')[0], 10));
  currentDate.setMinutes(parseInt(timeString.split(':')[1], 10));

  return currentDate.toLocaleTimeString(locale, { hour: '2-digit', minute: 'numeric' });
};
